/* Kavkaz — refonte ivoire */
(function () {
  var fmt = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; };

  /* Galerie produit */
  var main = document.getElementById('pf-img');
  document.querySelectorAll('[data-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (main) { main.src = b.getAttribute('data-thumb'); main.alt = b.getAttribute('aria-label') || ''; }
      document.querySelectorAll('[data-thumb]').forEach(function (o) { o.classList.remove('on'); });
      b.classList.add('on');
    });
  });

  /* Choix du format */
  var form = document.getElementById('product-form');
  function upd() {
    if (!form) return;
    var r = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
    if (!r) return;
    var cents = parseInt(r.getAttribute('data-cents') || '0', 10);
    var isPack = r.getAttribute('data-is-pack') === 'true';
    var addon = document.getElementById('addon-brush');
    if (addon) {
      addon.hidden = isPack;
      var cb = addon.querySelector('.addon-checkbox');
      if (isPack && cb) cb.checked = false;
      if (cb && cb.checked) cents += parseInt(addon.getAttribute('data-cents') || '0', 10);
    }
    var gift = document.getElementById('gift-brush');
    if (gift) gift.hidden = !isPack;
    var label = isPack ? (form.getAttribute('data-cta-pack') || 'Commencer la cure') : 'Ajouter au panier';
    var cta = document.getElementById('main-atc');
    if (cta && !cta.disabled) cta.textContent = label + ' — ' + fmt(cents);
    var sp = document.getElementById('sticky-price'); if (sp) sp.textContent = fmt(cents);
    var sl = document.getElementById('sticky-label'); if (sl) sl.textContent = r.getAttribute('data-label') || '';
    if (main && r.getAttribute('data-img')) main.src = r.getAttribute('data-img');
    var rs = document.getElementById('reviews-solo-block'), rp = document.getElementById('reviews-pack-block');
    if (rs && rp) { rs.style.display = isPack ? 'none' : ''; rp.style.display = isPack ? '' : 'none'; }
  }
  if (form) {
    form.addEventListener('change', upd);
    upd();
  }

  /* Barre d'achat fixe (mobile) : visible tant que le bouton principal n'est pas à l'écran */
  var sticky = document.querySelector('.sticky-atc');
  var atc = document.getElementById('main-atc');
  if (sticky && atc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { sticky.classList.toggle('show', !e.isIntersecting); });
    }).observe(atc);
    var sb = sticky.querySelector('button');
    if (sb) sb.addEventListener('click', function () { if (form) { if (form.requestSubmit) form.requestSubmit(atc); else atc.click(); } });
  }

  /* Liste des 14 actifs */
  var tg = document.getElementById('inci-toggle');
  if (tg) tg.addEventListener('click', function () {
    var more = document.getElementById('inci-more');
    var open = more.hidden;
    more.hidden = !open;
    tg.setAttribute('aria-expanded', open ? 'true' : 'false');
    tg.textContent = open ? 'Réduire la liste' : 'Voir les 14 actifs';
  });

  /* Diagnostic */
  var dq = document.getElementById('dq');
  if (dq) {
    var st = { zone: null, pb: null, dur: null };
    var show = function (id) {
      dq.querySelectorAll('[data-step]').forEach(function (s) { s.hidden = s.getAttribute('data-step') !== id; });
      window.scrollTo({ top: dq.offsetTop - 120, behavior: 'smooth' });
    };
    dq.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      if (b.hasAttribute('data-back')) { show(b.getAttribute('data-back')); return; }
      if (b.hasAttribute('data-restart')) { st = { zone: null, pb: null, dur: null }; show('1'); return; }
      var k = b.getAttribute('data-k'), v = b.getAttribute('data-v');
      if (!k) return;
      st[k] = v;
      if (k === 'zone') { show(v === 'corps' ? '2c' : '2h'); return; }
      if (k === 'pb') { show(st.zone === 'corps' ? '3c' : '3h'); return; }
      var res;
      if (st.zone === 'corps') res = st.dur === 'long' ? 'gw3' : 'gw1';
      else res = ((st.pb === 'pellicules' || st.pb === 'gras') && st.dur === 'court') ? 'gb1' : 'gb3';
      show('r-' + res);
    });
  }
})();
